// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_2pQ3DvxvWVpLQwx-X6R4wA","rotate":"_3Ics65O2OcvFHqZULABHi6","visible":"rZ66G9CeRsh5LIiD_JrPI"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/loaders/LoadingSpinner.css
// module id = 264
// module chunks = 0